const statusModule = {
  payStatus0: "未支付",
  payStatus1: "支付完成",
  payStatus3: "退款成功",
  payStatus4: "退款失敗",
  "orderStatus-1": "已取消",
  orderStatus0: "待處理",
  orderStatus1: "已確認",
  orderStatus2: "已完成",
  orderAll: "全部",
  payFun3: "現金支付",
  payFun3_1: "現金支付",
  Monday: "星期一",
  Tuesday: "星期二",
  Wednesday: "星期三",
  Thursday: "星期四",
  Friday: "星期五",
  Saturday: "星期六",
  Sunday: "星期日",
  zhuri: '祝日',
  sex0: "保密",
  sex1: "男",
  sex2: "女",
  loading: "正在加載",
  noMore: "沒有更多了",
  feedbackType0: "關於訂單",
  feedbackType1: "關於會員信息",
  feedbackType2: "關於使用方法",
  feedbackType3: "其它",
  payType1: "微信支付",
  payType2: "支付寶",
  payType3: "信用卡支付"
};
export default statusModule;
